document.addEventListener('DOMContentLoaded', function() {
  var lastScroll = 0;
  var header = document.getElementById('header-component');
  if (!header) return;
  window.addEventListener('scroll', function() {
    var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScroll > lastScroll && currentScroll > 50) {
      // scrolling down
      header.classList.add('header--hidden');
    } else {
      // scrolling up
      header.classList.remove('header--hidden');
    }
    lastScroll = currentScroll <= 0 ? 0 : currentScroll; // For negative scrolling
  });
});
